<p-table #dt [columns]="cols" [value]="listArchives | async">
    <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: left">
            <button type="button" pButton icon="pi pi-file-o" iconPos="left" label="CSV" (click)="dt.exportCSV()"
                class="btn-def" style="margin-right: 0.5em;"></button>
            <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL" (click)="exportExcel()"
                style="margin-right: 0.5em;" class="btn-def"></button>
            <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF" (click)="exportPdf()"
                class="btn-def"></button>
            <span style="float: right;">
                <span *ngIf="dt.filteredValue">
                    <span style="color: red;"> {{prosuisSum}}</span>

                    {{dt.filteredValue.length}} / </span>{{dt.totalRecords}} Materiel
            </span>

        </div>
    </ng-template>



    <ng-template pTemplate="header" let-colsVaraible>
        <tr>
            <th *ngFor="let col of colsVaraible" [style.width]="col.width">
                {{col.header}}
            </th>
            <th style="width: 100px;">Fiche Client</th>

        </tr>

        <tr>
            <th *ngFor="let col of cols" [ngSwitch]="col.field">

                <p-dropdown *ngSwitchCase="'type'" [options]="types" [style]="{'width':'100%'}"
                    (onChange)="dt.filter($event.value, col.field, 'equals')"></p-dropdown>
                <input *ngSwitchCase="'standList'" style="width:100% ;" pInputText type="text"
                    (input)="dt.filter($event.target.value, col.field, 'startsWith')">
                <input style="width:100% ;" *ngSwitchDefault pInputText type="text"
                    (input)="dt.filter($event.target.value, col.field, 'contains')">

            </th>




            <th style="width: 100px;"> </th>
        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-row let-colsVaraible="columns">
        <tr>
            <td *ngFor="let col of colsVaraible" [ngSwitch]="col.field">
                <div *ngSwitchCase="'type'">{{convertType(row[col.field])}} </div>
                <div *ngSwitchDefault>{{row[col.field]}}</div>

            </td>
            <td>
                <mat-icon [routerLink]="['/add-exhibitor',{idClient:row.idClient}]">folder_open</mat-icon>
            </td>
        </tr>
    </ng-template>


</p-table>